<template>
  <div class="step step_9"  :class="{'form__step_hidden': step != number}">
    <RadioGroup :disabled="copy" :value="stepsdata[currentnumber][getName(names[0])]" @input="$set(stepsdata[number],names[0], $event)" :grid="true" :name="names[0]" title="Сведения о занятости застрахованного лица" :required="true" :values="['Работа по найму','Собственник бизнеса']"/>
    <TextInput :disabled="copy" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[1])]" @input="$set(stepsdata[number],names[1], $event)" :name="names[1]" :increased="!stepsdata[number][names[1]]" text="Наименование*" :required="true"/>
    <TextInput :disabled="copy" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[2])]" @input="$set(stepsdata[number],names[2], $event)" :name="names[2]" :increased="!stepsdata[number][names[2]]" text="Должность*" :required="true"/>
    <TextInput :disabled="copy" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[3])]" @input="$set(stepsdata[number],names[3], $event)" :name="names[3]" :increased="!stepsdata[number][names[3]]" text="Юридический адрес*" :required="true"/>
    <NumberInput :filled="(v)=>v.length==18" mask='+7 (###) ###-##-##'  :disabled="copy" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[4])]" @input="$set(stepsdata[number],names[4], $event)" :name="names[4]" :increased="!stepsdata[number][names[4]]" text="Рабочий телефон*" :required="true"/>

    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import RadioGroup from './RadioGroup.vue'
import Btn from './ui/Btn.vue'
import TextInput from '@/components/TextInput.vue'
import { mapState } from 'vuex'
import NumberInput from './NumberInput.vue'

export default {
  components: { Btn, TextInput, RadioGroup, NumberInput },
  data: ()=>({
    errorcont: {},
    names: ['repeatpolicyholderjobtype','repeatpolicyholderjobname','repeatpolicyholderjobposition','repeatpolicyholderjoblegaladress','repeatpolicyholderbusinessphone']
  }),
  props: {
    number: {type: Number, default: 9},
    copyslidenumber: {type: Number, default: 5},
  },
  methods:{
    getName(name){
      if (this.copy)
        return name.replace('repeatpolicy','client')
      return name
    }
  },
  computed: {
    ...mapState(['stepsdata','step', 'copy']),
    currentnumber(){
      return this.copy?this.copyslidenumber:this.number
    },
    filled(){
      for (let name of this.names)
        if (!this.stepsdata[this.number][name] || this.errorcont[name])
          return false
      return  true
    }
  },
}
</script>

<style lang="sass">

</style>